export const GUEST_REPORT_LIST_INITING = 'GUEST_REPORT_LIST_INITING'
export const GUEST_REPORT_LIST_REQUESTING = 'GUEST_REPORT_LIST_REQUESTING'
export const GUEST_REPORT_LIST_SUCCESS = 'GUEST_REPORT_LIST_SUCCESS'
export const GUEST_REPORT_LIST_ERROR = 'GUEST_REPORT_LIST_ERROR'

export const GUEST_REPORT_NVKD_REQUESTING = 'GUEST_REPORT_NVKD_REQUESTING'
export const GUEST_REPORT_NVKD_SUCCESS = 'GUEST_REPORT_NVKD_SUCCESS'
export const GUEST_REPORT_NVKD_ERROR = 'GUEST_REPORT_NVKD_ERROR'

export const GUEST_REPORT_KH_REQUESTING = 'GUEST_REPORT_KH_REQUESTING'
export const GUEST_REPORT_KH_SUCCESS = 'GUEST_REPORT_KH_SUCCESS'
export const GUEST_REPORT_KH_ERROR = 'GUEST_REPORT_KH_ERROR'

export const GUEST_REPORT_EXPORT_XLS_REQUESTING = 'GUEST_REPORT_EXPORT_XLS_REQUESTING'
export const GUEST_REPORT_EXPORT_XLS_SUCCESS = 'GUEST_REPORT_EXPORT_XLS_SUCCESS'
export const GUEST_REPORT_EXPORT_XLS_ERROR = 'GUEST_REPORT_EXPORT_XLS_ERROR'

export const GUEST_REPORT_KH_BY_NHOM_REQUESTING = 'GUEST_REPORT_KH_BY_NHOM_REQUESTING'
export const GUEST_REPORT_KH_BY_NHOM_SUCCESS = 'GUEST_REPORT_KH_BY_NHOM_SUCCESS'
export const GUEST_REPORT_KH_BY_NHOM_ERROR = 'GUEST_REPORT_KH_BY_NHOM_ERROR'

export const GUEST_REPORT_NHOMKH_REQUESTING = 'GUEST_REPORT_NHOMKH_REQUESTING'
export const GUEST_REPORT_NHOMKH_SUCCESS = 'GUEST_REPORT_NHOMKH_SUCCESS'
export const GUEST_REPORT_NHOMKH_ERROR = 'GUEST_REPORT_NHOMKH_ERROR'

export const GUEST_REPORT_NVKD_API = '/api/v1/users/get_list_by_quanly'
export const GUEST_REPORT_KH_API = '/api/v1/khachhang/KhachByNvkd'
export const GUEST_REPORT_LIST_API = '/api/v1/report/baoCaoGiaoDich'
export const GUEST_REPORT_EXPORT_XLS_API = '/api/v1/report/bao_cao_giao_dich_export_by_store' 
export const GUEST_REPORT_NHOMKH_API = '/api/v1/nhomkhachhang/nhomkhachhang_list_actived_by_store'
export const GUEST_REPORT_KH_BY_NHOM_API = '/api/v1/khachhang/khachhangByNhomOrNvkd'


// WEBPACK FOOTER //
// ./src/views/Reports/GuestReport/constants.js